var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.393,
    height: 73.522,
    viewBox: "0 0 171.393 73.522",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_293",
    "data-name": "Raggruppa 293",
    transform: "translate(-138.521 -973.594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_56",
    "data-name": "Tracciato 56",
    d: "M2456.05,1283.737a15.794,15.794,0,0,0-15.794,15.794,16.077,16.077,0,0,0,16.122,15.793,15.517,15.517,0,0,0,15.466-15.793,15.794,15.794,0,0,0-15.794-15.794m0,26.718a10.925,10.925,0,1,1,10.925-10.925,10.925,10.925,0,0,1-10.925,10.925",
    transform: "translate(-2161.929 -291.305)",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_57",
    "data-name": "Tracciato 57",
    d: "M1956.912,1293.169h-10.227v4.12h1.79a.976.976,0,0,1,.973.974v14.486l-14.462-19.581-.021.016v-.014h-5.93v4.12h1.846a.976.976,0,0,1,.973.974h0V1318.5h0a.976.976,0,0,1-.974.973h-1.789v4.1h10.227v-4.1h-1.79a.976.976,0,0,1-.973-.974h0v-14.947l15.125,20.035,0,0,0,.008h2.454v-25.329a.976.976,0,0,1,.974-.97h1.795Z",
    transform: "translate(-1681.76 -300.163)",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_58",
    "data-name": "Tracciato 58",
    d: "M1416.391,1319.481a1.085,1.085,0,0,1-.182-.166l-3.206-4.428a10.956,10.956,0,0,0-2.117-21.7h-17.606v4.569h1.85a.976.976,0,0,1,.97.973v19.792a.977.977,0,0,1-.974.971h-1.855v4.12H1403.5v-4.12h-1.856a.977.977,0,0,1-.973-.975V1315.1h7.169l2.887,3.988s.179.193.073.347c-.079.115-.309.1-.309.1h-1.844v4.12h10.228v-4.12h-2.19a1.26,1.26,0,0,1-.292-.054m-5.55-8.948h-10.172v-12.774h10.172v.008a6.383,6.383,0,1,1,0,12.766Z",
    transform: "translate(-1178.536 -300.184)",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_59",
    "data-name": "Tracciato 59",
    d: "M868.693,1288.609a10.9,10.9,0,0,1,8.182,3.689v-.021l.089.158.533.015h2.4v-8.136h-4.134v.821a.156.156,0,0,1-.02.053.265.265,0,0,1-.085.082c-.076.042-.181,0-.326-.068a15.793,15.793,0,1,0-.019,28.672,1.038,1.038,0,0,1,.23-.1c.049-.009.124-.025.169.021a.162.162,0,0,1,.051.082v.875H879.9v-8.136h-2.317l-.615,0-.1.159a10.921,10.921,0,0,1-18.842-4.908h17.65v-4.9h-17.6a10.927,10.927,0,0,1,10.62-8.365",
    transform: "translate(-670.987 -291.308)",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_60",
    "data-name": "Tracciato 60",
    d: "M154.673,1028.169V998.691H171.05l-.006,19.647h0a.976.976,0,0,1-.975.973h-2.61v4.114h12.587v-4.114H177.43a.976.976,0,0,1-.973-.971v-1.5h0V978.662a.975.975,0,0,1,.95-.97l2.639,0v-4.1H167.46v4.1h2.618a.976.976,0,0,1,.973.97v2.242h0v12.1H154.673V978.668h0a.976.976,0,0,1,.974-.973h2.643v-4.1H145.7v4.1h2.6a.976.976,0,0,1,.967.966v49.507h-6.8a3.663,3.663,0,0,0-.418-.006,3.53,3.53,0,0,0-2.739,5.758l-.009.007,10.244,13.14c.051.051.215.048.215.048h4.909v-13.54h153.9v-5.407Zm-5.407,9.741-3.378-4.333h3.378Z",
    transform: "translate(0)",
    fill: "#000001"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLogo);
export default __webpack_public_path__ + "static/media/login-logo.4296726499cf80c45493e47b21f02106.svg";
export { ForwardRef as ReactComponent };